import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieContext = createContext();

export const CookieProvider = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState(() => {
    const saved = localStorage.getItem('sdtlab-cookie-consent');
    return saved ? JSON.parse(saved) : null;
  });

  const [showBanner, setShowBanner] = useState(!cookieConsent);

  useEffect(() => {
    if (cookieConsent) {
      localStorage.setItem('sdtlab-cookie-consent', JSON.stringify(cookieConsent));
    }
  }, [cookieConsent]);

  const acceptAll = () => {
    setCookieConsent({ necessary: true, analytics: true });
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    setCookieConsent({ necessary: true, analytics: false });
    setShowBanner(false);
  };

  const updateConsent = (preferences) => {
    setCookieConsent({ necessary: true, ...preferences });
    setShowBanner(false);
  };

  const resetConsent = () => {
    localStorage.removeItem('sdtlab-cookie-consent');
    setCookieConsent(null);
    setShowBanner(true);
  };

  return (
    <CookieContext.Provider value={{
      cookieConsent,
      showBanner,
      setShowBanner,
      acceptAll,
      acceptNecessary,
      updateConsent,
      resetConsent
    }}>
      {children}
    </CookieContext.Provider>
  );
};

export const useCookies = () => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error('useCookies must be used within a CookieProvider');
  }
  return context;
};